export default {
    currentYearDate() {
        const d = new Date();
        return d.getFullYear()
    },
    map_address_hostel: {
        'Общежитие № 1': 'адрес 1',
        'Общежитие № 2': 'адрес 2',
        'Общежитие № 3': 'адрес 3',
        'Общежитие № 3Л': 'адрес 3л',
    },
    data_contract: {
        space: '____________________________________________________________________________',
    },
    calcSpace(full_name) {
        return this.data_contract.space.slice(full_name.length)
    },
    tableBody(){
        let res_body = []
        let arr_header = [{text: 'Наименование', style: 'tableHeader', alignment: 'left'}, {text: 'Количество', style: 'tableHeader', alignment: 'center'}, {text: 'Инвентарный номер', style: 'tableHeader', alignment: 'center'}]
        res_body.push(arr_header)
        //
        // if (list_trans_props.length > 0){
        //     list_trans_props.forEach((item) => {
        //         res_body.push([item.name_prop, item.count_prop, item.invent_num])
        //     })
        // } else {
        //
        // }

        for (let i = 0; i < 13; i++ ){
            res_body.push(['','',''])
        }

        return res_body
    },
    tableBodyDevise(electronic_devices){
        let res_body = []
        let arr_header = [{text: 'ПРИБОР', style: 'tableHeader', alignment: 'center'}, {text: 'Рублей в месяц', style: 'tableHeader', alignment: 'center'}, {text: 'Наличие у Нанимателя\n' +
                '(V)', style: 'tableHeader', alignment: 'center'}]
        let devise = [
            ['СВЧ – печь', { text: '76,80', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'СВЧ – печь') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Электрочайник', { text: '100,80', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Электрочайник') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Утюг', { text: '10,66', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Утюг') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Фен', { text: '26,40', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Фен') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Телевизор', { text: '40,32', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Телевизор') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Компьютер', { text: '128,00', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Компьютер') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Холодильник', { text: '280,32', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Холодильник') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Принтер лазерный', { text: '144,00', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Принтер лазерный') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Принтер струйный', { text: '14,40', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Принтер струйный') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['МФУ', { text: '57,60', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'МФУ') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Мультиварка, рисоварка, пароварка', { text: '115,20', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Мультиварка') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Ноутбук', { text: '145,92', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Ноутбук') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Потер', { text: '92,16', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Потер') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Прочие бытовые электроприборы: зарядные устройства к ' +
            'телефону, магнитофон, плойка, колонки', { text: '9,60', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Прочие бытовые электроприборы: зарядные устройства к телефону, магнитофон, плойка, колонки') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Машинка стиральная (автомат)', { text: '94,37', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Машинка стиральная (автомат)') ? "V" : "", style: 'normal', alignment: 'center'}],
            ['Машинка стиральная (полуавтомат)', { text: '24,00', style: 'normal', alignment: 'center'}, { text: !!_.find(electronic_devices, (o) => o.name === 'Машинка стиральная (полуавтомат)') ? "V" : "", style: 'normal', alignment: 'center'}],
            [{ text: 'Итог', style: 'normal', alignment: 'left', colSpan: 2} , '', { text: _.sumBy(electronic_devices, 'price').toFixed(2), style: 'normal', alignment: 'center'}],
        ]

        res_body.push(arr_header)
        return  [...res_body, ...devise];

    },

    createPDF(full_name, name_hostel, name_section, name_room, registration_address, identity_card, electronic_devices){
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        };
        const docInfo = {
            info: {
                title: `АмГУ, заявление на заселение.`,
                author: 'ЦЦТиТО, АмГУ',
                subject: '',
                keywords: ''
            },

            pageSize: 'A4',
            pageOrientation: 'portrait',

            content: [
                { text: 'ДОГОВОР № ____ \n', style: 'name_contract'},
                { text: 'найма жилого помещения в студенческом общежитии', style: 'name_contract', margin: [0, 0, 0, 10]},

                {
                    columns: [
                        {
                            width: 'auto',
                            text: 'город Благовещенск Амурской области',
                            margin: [0, 0, 0, 10],
                            style: 'normal',
                        },
                        {
                            width: '*',
                            text: `«___» _____________ ${ this.currentYearDate() } год`,
                            margin: [0, 0, 0, 10],
                            style: 'normal'
                        },
                    ],
                    columnGap: 150
                },

                { text: 'Федеральное    государственное   бюджетное    общеобразовательное    учреждение   высшего   образования   «Амурский ' +
                        'государственный университет», именуемое в дальнейшем «Наймодатель» в лице проректора по молодёжной политике Ерёминой ' +
                        'Виктории Владимировны, действующей на основании приказа от 05.09.2022 года № 294-ОД, с одной стороны,', style: 'normal', alignment: 'justify' },

                {
                    text: [
                        'и гражданин(ка)',
                        {text: `   ${full_name} ${this.calcSpace(full_name)}`, style: 'base_text', decoration: 'underline'},
                        ','
                    ],
                    style: 'normal'
                },

                { text: 'именуемый(ая) в дальнейшем «Наниматель», с другой стороны, на основании приказа о предоставлении жилого помещения' +
                        'от «___» _____________ 2023 года № __________, заключили настоящий Договор о нижеследующем.', style: 'base_text' },

                { text: '1. ПРЕДМЕТ ДОГОВОРА', style: 'header', margin: [0, 10, 0, 0]},

                { text: `1.1. Наймодатель предоставляет для проживания на весь период обучения с ____________ по ____________ место в комнате № ${ name_room }, `+
                        `секции № ${ name_section }, ${ name_hostel.toLowerCase()  }, расположенного по адресу _________________________________, `+
                        'общей площадью _____ кв.м. (далее – жилое помещение) для временного проживания в нем.', style: 'normal' },

                { text: '1.2. Жилое помещение предоставляется в связи с обучением Нанимателя в Амурском государственном университете.', style: 'normal' },

                { text: '1.3. Характеристика предоставляемого жилого помещения, его технического состояния, а также санитарно-технического и '+
                        'иного оборудования, находящегося в нем, содержится в техническом паспорте жилого помещения.', style: 'normal' },

                { text: '1.4. Настоящий Договор заключается на время обучения.', style: 'normal'},

                { text: '1.5. Жилое помещение в студенческом общежитии передается в соответствии с актом прием-передачи жилого помещения,\n'+
                        'являющимся неотъемлемой частью настоящего договора (Приложение № 1) и возвращается в соответствии с актом возврата '+
                        'жилого помещения, являющимся неотъемлемой частью настоящего договора (Приложение № 4).', style: 'normal'},

                { text: '2. СТОИМОТЬ ПРОЖИВАНИЯ В СТУДЕНЧЕСКОМУ ОБЩЕЖИТИИ И ПОРЯДОК ОПЛАТЫ', style: 'header', margin: [0, 10, 0, 0] },

                { text: '2.1. Стоимость проживания в студенческом общежитии устанавливается приказом ректора Амурского государственного '+
                        'университета в соответствии с нормативно-правовыми актами Российской Федерации, субъекта Российской Федерации (Амурской '+
                        'области), нормативными актами главы муниципального образования (г. Благовещенк), а также локальными нормативными актами ' +
                        'Амурского государственного университета.', style: 'normal'},

                { text: '2.2. В случае изменения стоимости проживания в студенческом общежитии Наймодатель уведомляет Нанимателя об ' +
                        'изменении стоимости проживания в студенческом общежитии путем размещения информации в месте проживания Нанимателя в ' +
                        'студенческом общежитии, а также на официальном сайте Амурского государственного университета (www.amursu.ru) не менее ' +
                        'чем за 1 (один) месяц до изменения стоимости проживания в студенческом общежитии.', style: 'normal'},

                { text: '2.3. Наниматель вносит плату за проживание в студенческом общежитии ежемесячно до 10 (десятого) числа месяца, ' +
                        'следующего за оплачиваемым месяцем. Плата за проживание в студенческом общежитии может взиматься ежемесячно или сразу ' +
                        'за несколько месяцев вперед (за семестр, за год).', style: 'normal'},

                { text: '2.4. Плата за проживание в студенческом общежитии вносится Нанимателем наличными денежными средствами в кассу ' +
                        'Федерального государственного бюджетного общеобразовательного учреждения высшего образования «Амурский ' +
                        'государственный университет» либо перечисляется в безналичном порядке на расчетный счет Амурского государственного ' +
                        'университета по реквизитам, указанным в настоящем Договоре. Копия документа об оплате предоставляется Нанимателем ' +
                        'коменданту общежития.', style: 'normal'},

                { text: '2.5. От платы за проживание в студенческом общежитии освобождаются лица, находящиеся на полном государственном ' +
                        'обеспечении (дети-сироты и дети, оставшиеся без попечения родителей, лица из их числа до окончания ими обучения), а также ' +
                        'инвалиды I и II группы.', style: 'normal'},

                { text: '2.6. По согласованию сторон, выраженному подписанием настоящего Договора, в случае получения Нанимателем ' +
                        'стипендии в Амурском государственном университете, стоимость проживания в студенческом общежитии удерживается из такой ' +
                        'стипендии.', style: 'normal'},

                { text: '3. ПРАВА И ОБЯЗАННОСТИ НАНИМАТЕЛЯ', style: 'header', margin: [0, 10, 0, 0]},
                { text: '3.1. Наниматель имеет право:', style: 'normal', decoration: 'underline' },
                { text: '3.1.1. на использование жилого помещения для проживания;', style: 'normal' },
                { text: '3.1.2. на пользование общим имуществом в общежитии;', style: 'normal' },
                { text: '3.1.3. на использование личных электроприборов на условиях, оговоренных сторонами в соответствующем' +
                        ' соглашении к настоящему договору (Приложение № 2);', style: 'normal' },
                { text: '3.1.4. на расторжение в любое время настоящего Договора.', style: 'normal'},
                { text: 'Наниматель может иметь иные права, предусмотренные законодательством Российской Федерации.', style: 'normal'},
                { text: '3.2. Наниматель обязан:', style: 'normal', decoration: 'underline' },
                { text: '3.2.1. использовать жилое помещение по назначению и в пределах, установленных Жилищным кодексом Российской ' +
                        'Федерации;', style: 'normal' },
                { text: '3.2.2. соблюдать правила пользования жилым помещением, а также правила внутреннего распорядка в общежитиях АмГУ;', style: 'normal' },
                { text: '3.2.3. обеспечивать сохранность жилого помещения, поддерживать его в надлежащем состоянии. Самовольное ' +
                        'переустройство или перепланировка жилого помещения не допускается;', style: 'normal' },
                { text: '3.2.4. обеспечивать сохранность имущества Наймодателя, находящегося в жилом помещении и местах общего пользования;', style: 'normal' },
                { text: '3.2.5. поддерживать чистоту и порядок в местах общего пользования;', style: 'normal' },
                { text: '3.2.6. предоставить дубликат ключей от жилого помещения коменданту общежития в течении 1 (одного) календарного дня' +
                        ' с момента заселения;', style: 'normal' },
                { text: '3.2.7. своевременно вносить плату за проживание в студенческом общежитии. Обязанность вносить плату за проживание в' +
                        'студенческом общежитии возникает с момента заключения настоящего Договора;', style: 'normal' },
                { text: '3.2.8. допускать в жилое помещение в любое время представителя Наймодателя для осмотра технического состояния ' +
                        ' жилого помещения, санитарно-технического и иного оборудования, находящегося в нем, а также для выполнения необходимых работ; ', style: 'normal' },
                { text: '3.2.9. при обнаружении неисправностей и повреждений жилого помещения, предоставленной Наймодателем мебели или ' +
                        'санитарно-технического и иного оборудования, находящегося в нем, немедленно принимать меры к их устранению и в случае ' +
                        'необходимости сообщать о них Наймодателю. В случае, если неисправности и повреждения жилого помещения, предоставленнойНаймодателем мебели или санитарно-технического и иного оборудования, находящегося в нем, произошли по вине Нанимателя ' +
                        '(неправильная эксплуатация, преднамеренная порча и проч.) их устранение производится полностью за счет Нанимателя; ', style: 'normal' },
                { text: '3.2.10. осуществлять пользование жилым помещением с учетом соблюдения прав и законных интересов соседей, ' +
                        'требований пожарной безопасности, санитарно-гигиенических, экологических и иных требований законодательства;', style: 'normal' },
                { text: '3.2.11. незамедлительно информировать коменданта общежития о неудовлетворительном самочувствии для принятия ' +
                        'своевременных мер, предупреждающих распространение инфекционных заболеваний;', style: 'normal' },
                { text: '3.2.12. при освобождении жилого помещения сдать его в течение трех дней Наймодателю в надлежащем состоянии;', style: 'normal' },
                { text: '3.2.13. при расторжении или прекращении настоящего Договора освободить жилое помещение. В случае отказа освободить ' +
                        'жилое помещение Наниматель подлежат выселению в судебном порядке.', style: 'normal' },
                { text: '3.2.14. Наниматель жилого помещения несет иные обязанности, предусмотренные законодательством.', style: 'normal'},
                { text: '3.3. Нанимателю категорически ЗАПРЕЩАЕТСЯ:', style: 'normal', decoration: 'underline', },
                { text: '3.3.1. курение табака, а также использование курительных приборов (кальянов, вейпов, электронных сигарет и т.п.), ' +
                        'потребление (распитие) алкогольной продукции, нахождение проживающего в общежитии в состоянии, оскорбляющем честь и ' +
                        'достоинство проживающих, а также хранение, употребление, продажа запрещенных законодательством РФ препаратов, ' +
                        'наркотических веществ на территориях, прилегающих к общежитиям, и в помещениях общежитий, в том числе в подъездах, на ' +
                        'лестницах, лестничных площадках, в лифтах.', style: 'normal'},
                { text: 'Нахождение проживающего в состоянии алкогольного, наркотического или иного токсического опьянения при совершении ' +
                        'дисциплинарного проступка рассматривается как отягчающее обстоятельство;', style: 'normal' },
                { text: '3.3.2. хранить и использовать в общежитии пиротехнические, взрывчатые, химически опасные вещества, любой вид ' +
                        'огнестрельного, травматического, пневматического, метательного или холодного оружия и т.п.;', style: 'normal' },
                { text: '3.3.3. нарушать противопожарные и санитарные правила содержания помещений общежития;', style: 'normal' },
                { text: '3.3.4. содержать животных в помещениях общежитий;', style: 'normal' },
                { text: '3.3.5. выполнять в помещениях общежитий работы или осуществлять иную деятельность, создающую повышенный шум и ' +
                        'вибрацию, нарушающую нормальные условия проживания в общежитии других граждан;', style: 'normal' },
                { text: '3.3.6. пользоваться акустическими устройствами, иными устройствами до степени, нарушающей тишину в общежитии и ' +
                        'покой проживающих, в будние дни с 22:00 до 08:00 часов, в выходные дни (суббота, воскресенье) и установленные федеральным ' +
                        'законодательством нерабочие праздничные дни с 22:00 до 09:00 часов; нарушать дневную тишину с 13.00 до 15:00 часов;', style: 'normal' },
                { text: '3.3.7. самовольно переселяться из одного жилого помещения в другое;', style: 'normal' },
                { text: '3.3.8. переносить инвентарь общежития из жилого помещения, за которым он закреплен, в другое жилое помещение;', style: 'normal' },
                { text: '3.3.9. самостоятельно производить демонтаж и ремонт санитарно-технического и иного инженерного оборудования; ' +
                        'косметический ремонт занимаемого помещения без согласования с комендантом и отсутствием письменного заявления;', style: 'normal' },
                { text: '3.3.10. устанавливать дополнительные замки, щеколды, иные запирающие устройства на оконных рамах, ' +
                        'входной/межкомнатной двери жилого помещения, используемого для проживания, а также производить замену замков, иных ' +
                        'запирающих устройств без разрешения коменданта общежития;', style: 'normal' },
                { text: '3.3.11. предоставлять свое место для проживания другим лицам;', style: 'normal' },
                { text: '3.3.12. передавать пропуск прохода в общежитие другим гражданам;', style: 'normal' },
                { text: '3.3.13. использовать выделенные для проживания помещения в коммерческих целях, в том числе репетиторства;', style: 'normal' },
                { text: '3.3.14. проводить в общежитие посторонних лиц, оставлять их на ночлег;', style: 'normal' },
                { text: '3.3.15. допускать грубость и оскорбления в адрес проживающих, представителей обслуживающего персонала общежития, ' +
                        'организаций, проводящих ремонтно-восстановительные, профилактические или иные работы в общежитии;', style: 'normal' },
                { text: '3.3.16. использовать в жилом помещении источники открытого огня (свечи, бенгальские огни и т.п.);', style: 'normal'  },

                { text: '4. ПРАВА И ОБЯЗАННОСТИ НАЙМОДАТЕЛЯ', style: 'header', margin: [0, 10, 0, 0] },
                { text: '4.1. Наймодатель имеет право:', style: 'normal' },
                { text: '4.1.1. требовать своевременного внесения платы по настоящему Договору;', style: 'normal' },
                { text: '4.1.2. требовать расторжения настоящего Договора в случаях нарушения Нанимателем жилищного законодательства, ' +
                        'условий настоящего Договора и локальных актов Наймодателя.', style: 'normal' },
                { text: 'Наймодатель может иметь иные права, предусмотренные законодательством Российской Федерации.', style: 'normal' },
                { text: '4.2. Наймодатель обязан:', style: 'normal' },
                { text: '4.2.1. передать Нанимателю по акту приема-передачи жилого помещения свободное от прав иных лиц и пригодное для ' +
                        'проживания жилое помещение в состоянии, отвечающем требованиям пожарной безопасности, санитарно-гигиеническим, ' +
                        'экологическим и иным требованиям; ', style: 'normal' },
                { text: '4.2.2. принимать участие в надлежащем содержании и ремонте общего имущества, в котором находится жилое помещение;', style: 'normal' },
                { text: '4.2.3. осуществлять текущий и капитальный ремонт жилого помещения, проводить аварийные работы систем отопления, ' +
                        'водоснабжения, канализации, в случае аварии не по вине Нанимателя;', style: 'normal' },
                { text: '4.2.4. принимать участие в своевременной подготовке жилого дома, санитарно-технического и иного оборудования, ' +
                        'находящегося в нем, к эксплуатации в зимних условиях;', style: 'normal' },
                { text: '4.2.5. принять в установленные настоящим Договором сроки жилое помещение у Нанимателя с соблюдением условий, ' +
                       ' предусмотренных настоящим Договором;', style: 'normal' },
                { text: '4.2.6. Наймодатель несет иные обязанности, предусмотренные законодательством.', style: 'normal' },

                { text: '5. ОТВЕТСТВЕННОСТЬ СТОРОН', style: 'header', margin: [0, 10, 0, 0] },
                { text: '5.1. За нарушение условий настоящего Договора стороны несут ответственность в соответствии с нормами действующего ' +
                        'законодательства Российской Федерации.', style: 'normal' },
                { text: '5.2. В случае нарушения правил внутреннего распорядка в общежитиях АмГУ, а также иных нормативных актов, ' +
                        'регламентирующих проживание в общежитиях, Наймодатель вправе применить к Нанимателю следующие дисциплинарные ' +
                        'взыскания: замечание, выговор, выселение из общежития, отчисление из Амурского государственного университета с ' +
                        'расторжением настоящего Договора.', style: 'normal' },
                { text: '5.3. Наниматель обязан возмещать причиненный материальный ущерб в соответствии с законодательством Российской Федерации.', style: 'normal' },
                { text: '5.4. В случае невнесения платы в установленный настоящим Договором срок Наниматель уплачивает Наймодателю пени в ' +
                        'размере, установленном Жилищным кодексом Российской Федерации. Уплата пени не освобождает Нанимателя от оплаты по ' +
                        'настоящему договору.', style: 'normal'},

                { text: '6. РАСТОРЖЕНИЕ И ПРЕКРАЩЕНИЕ ДОГОВОРА', style: 'header', margin: [0, 10, 0, 0] },
                { text: '6.1. Наниматель в любое время может расторгнуть настоящий Договор.', style: 'normal' },
                { text: '6.2. Настоящий Договор может быть расторгнут в любое время по соглашению сторон.', style: 'normal' },
                { text: '6.3. Настоящий договор может быть расторгнут в судебном порядке по требованию Наймодателя при:', style: 'normal' },
                { text: '6.3.1. неисполнении Нанимателем обязательств по настоящему Договору;', style: 'normal' },
                { text: '6.3.2. невнесении Нанимателем платы за проживание в студенческом общежитии в течение более шести месяцев;', style: 'normal' },
                { text: '6.3.3. разрушении или повреждения Нанимателем жилого помещения, а также имущества Наймодателя, находящегося на ' +
                        'территории общежития (либо гражданами, за действия которых он отвечает), в котором ему предоставлено место для проживания, ' +
                        'оборудования и иного инвентаря;', style: 'normal' },
                { text: '6.3.4. систематическом нарушении прав и законных интересов лиц, проживающих в общежитии;', style: 'normal' },
                { text: '6.3.5. использовании жилого помещения не по назначению;', style: 'normal' },
                { text: '6.3.6. бесхозяйственном обращении с жилым помещением (повреждение, либо уничтожение структурных элементов ' +
                        'жилого помещения, окон, дверей, пола, стен, санитарно-технического оборудования и т.п.), допуская его разрушение;', style: 'normal' },
                { text: '6.3.7. несоблюдения п. 3.3. настоящего Договора.', style: 'normal' },
                { text: '6.4. Настоящий Договор прекращается в связи:', style: 'normal' },
                { text: '6.4.1. с утратой (разрушением) жилого помещения в общежитии;', style: 'normal' },
                { text: '6.4.2. со смертью Нанимателя;', style: 'normal' },
                { text: '6.4.3. с окончанием срока обучения;', style: 'normal' },
                { text: '6.4.4. с отчислением обучающегося из Амурского государственного университета;', style: 'normal' },
                { text: '6.4.5. с переходом на заочную форму обучения;', style: 'normal' },
                { text: '6.4.6. с переводом обучающегося в иное учебное заведение;', style: 'normal' },
                { text: '6.4.7. с истечением периода, на который был заключен настоящий Договор.', style: 'normal' },

                { text: '7. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЕ', style: 'header', margin: [0, 10, 0, 0]},
                { text: '7.1. Сведения, указанные в настоящем Договоре, соответствуют информации, размещенной на официальном сайте ' +
                        'Амурского государственного университета в сети Интернет на дату заключения настоящего Договора.', style: 'normal' },
                { text: '7.2. Споры, которые могут возникнуть между сторонами по настоящему Договору, разрешаются в порядке, ' +
                        'предусмотренном действующим законодательством Российской Федерации.', style: 'normal' },
                { text: '7.3. Настоящий Договор составлен в двух экземплярах, обладающих равной юридической силой, по одну для каждой из сторон.', style: 'normal' },
                { text: '7.4. Изменения и дополнения настоящего Договора могут производиться только в письменной форме и подписываться ' +
                        'уполномоченными представителями Сторон. Изменения Договора оформляются дополнительными соглашениями к Договору.', style: 'normal' },
                { text: '7.5. О любых изменениях данных стороны (в том числе, изменениях фамилии, адреса, паспортных данных и банковских ' +
                        'реквизитов) каждая из сторон обязана уведомить другую сторону.', style: 'normal' },
                { text: 'Университет уведомляет об изменении данных путем размещения информации на официальном сайте и информационном стенде.', style: 'normal' },

                { text: `7.6. Срок действие настоящего Договора с ____________ по ____________`, style: 'normal' },
                { text: '7.7. Неотъемлемыми частями настоящего Договора являются следующие приложения:', style: 'normal' },
                { text: '1. Приложение № 1 – Акт приема-передачи жилого помещения;', style: 'normal' },
                { text: '2. Приложение № 2 – Дополнительное соглашение об использовании личных электроприборов;', style: 'normal' },
                { text: '3. Приложение № 3 – Дополнительное соглашение о переселении;', style: 'normal' },
                { text: '4. Приложение № 4 - Акт возврата жилого помещения.', style: 'normal' },

                { text: '8. ЮРИДИЧЕСКИЕ АДРЕСА И РЕКВИЗИТЫ СТОРОН', style: 'header', margin: [0, 10, 0, 10] },

                {
                    columns: [
                        {
                            width: '50%',
                            text: 'Наймодатель\n' +
                                'Федеральное государственное бюджетное образовательное ' +
                                'учреждение высшего образования\n ' +
                                '«Амурский государственный университет»\n ' +
                                '675027 Россия, г. Благовещенск, Игнатьевское шоссе, 21\n ' +
                                'ИНН 2801027174 КПП 280101001\n ' +
                                'УФК по Амурской области г. Благовещенск (ФГБОУ ВО\n ' +
                                '«АмГУ», АмГУ л/с 20236Х50560)\n ' +
                                'р/с 03214643000000012300\n ' +
                                'ОТДЕЛЕНИЕ БЛАГОВЕЩЕНСК БАНК РОССИИ// УФК по\n ' +
                                'Амурской области г. Благовещенск,\n ' +
                                'БИК 011012100,\n ' +
                                'Кор. счет 40102810245370000015,\n ' +
                                'Назначение платежа КБК 00000000000000000130\n ' +
                                'ОКТМО: 10701000\n ' +
                                'ОКАТО: 10401000000\n ',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: 'Наниматель\n' +
                                `${full_name}\n` +
                                `\n` +
                                `Данные паспорта\n` +
                                `${identity_card.passport_data.issuing_authority} ${identity_card.passport_data.subdivision_code} ${identity_card.passport_data.issue_date}\n` +
                                `Адрес регистрации: ${registration_address}\n` +
                                `Серия и номер: ${identity_card.passport_data.series} ${identity_card.passport_data.number}\n` +
                                `\n` +
                                `ИНН: ${identity_card.inn}\n` +
                                `СНИЛС: ${identity_card.snils}\n`,
                            style: 'column'
                        },
                    ],
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: '_____________________В.В.Ерёмина',
                            alignment: 'left',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: '____________________________________',
                            alignment: 'right',
                            style: 'column'
                        },
                    ],
                },
                //////////////////////////////////////////Приложение №1////////////////////////////////////////////////////////
                {
                  columns: [
                      {
                          width: '50%',
                          text: '',
                          style: 'column'
                      },
                      {
                          width: '50%',
                          text: 'Приложение № 1\n' +
                                'к договору № ___ от __.__.______ года\n' +
                                'найма жилого помещения в студенческом общежитии',
                          alignment: 'left',
                          style: 'column'
                      },
                  ],
                    pageBreak: 'before',
                },
                {
                    text: 'АКТ ПРИЕМА-ПЕРЕДАЧИ ЖИЛОГО ПОМЕЩЕНИЯ',
                    style: 'header',
                    margin: [0, 50, 0, 10]
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: 'Город Благовещенск Амурской области',
                            style: 'column',
                            alignment: 'left'
                        },
                        {
                            width: '50%',
                            text: `«___» _________________ ${ this.currentYearDate() } г.`,
                            alignment: 'right',
                            style: 'column'
                        },
                    ],
                    leadingIndent: 18,
                    margin: [0, 0, 0, 10]
                },
                {
                    text:
                        [
                            'Федеральное государственное бюджетное общеобразовательное учреждение высшего образования «Амурский ' +
                            'государственный университет», именуемое по договору «Наймодатель» в лице проректора по молодёжной политике Ерёминой ' +
                            'Виктории Владимировны, действующей на основании приказа от 05.09.2022 года № 294-ОД, с одной стороны,\n',
                            'и гражданин(ка)',
                            {text: `   ${full_name} ${this.calcSpace(full_name)}`, style: 'base_text', decoration: 'underline'},
                            ',\n',
                            'именуемый(ая) по договору «Наниматель», с другой стороны, совместно составили настоящий Акт о том, что:',
                    ],
                    style: 'normal',
                    margin: [0, 0, 0, 10]
                },
                {
                    text: '1. Наймодатель передал, а Наниматель принял во временное пользование для временного проживания в нем, место в ' +
                        `комнате №_______, секции №_________, общежития №_____, расположенного по адресу ____________________________, ` +
                        'общей площадью _____ кв.м. (жилое помещение), находящегося в государственной собственности, закрепленного за ' +
                        'Наймодателем на праве оперативного управления.',
                    style: 'normal'
                },
                {
                    text: '2. Наймодатель предоставляет Нанимателю жилое помещение, соответствующее санитарным и техническим нормам, ' +
                        'пригодно для проживания.',
                    style: 'normal'
                },
                {
                    text: '3. Во временное пользование Нанимателю передано следующее имущество Наймодателя (оборудование, мебель и ' +
                        'инвентарь):',
                    style: 'normal'
                },
                {
                    style: 'tableBase',
                    table: {
                        widths: ['70%', '10%', '20%'],
                        heights: 7,
                        headerRows: 3,
                        body: this.tableBody()
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            return 0.4;
                        },
                        vLineWidth: function (i, node) {
                            return 0.4;
                        },
                        hLineColor: function (i, node) {
                            return 'black'
                        },
                        vLineColor: function (i, node) {
                            return 'black'
                        },
                    }
                },
                {
                    text: 'В случае порчи, уничтожения либо иного приведения в негодность имущества, принадлежащего Наймодателю, Наниматель ' +
                        'обязан незамедлительно возместить стоимость такого имущества по данным бухгалтерского учета Наймодателя.',
                    style: 'normal'
                },
                {
                    text: '4. Наниматель ключи получил, претензий к жилому помещению не имеет.',
                    style: 'normal'
                },
                {
                    text: '5. С даты подписания настоящего Акта:',
                    style: 'normal'
                },
                {
                    text: '5.1. обязанность Наймодателя по предоставлению Нанимателю жилого помещения в общежитии считается исполненной;',
                    style: 'normal'
                },
                {
                    text: '5.2. Наниматель несет бремя содержания переданного жилого помещения, а также исполняет иные обязанности, предусмотренные законодательством Российской Федерации.',
                    style: 'normal'
                },
                {
                    text: '6. Настоящий Акт составлен в двух экземплярах, имеющих одинаковую юридическую силу, для каждой из сторон.',
                    style: 'normal'
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: 'Наймодатель\n' +
                                'Федеральное государственное бюджетное образовательное ' +
                                'учреждение высшего образования\n ' +
                                '«Амурский государственный университет»\n ' +
                                '675027 Россия, г. Благовещенск, Игнатьевское шоссе, 21\n ' +
                                'ИНН 2801027174 КПП 280101001\n ' +
                                'УФК по Амурской области г. Благовещенск (ФГБОУ ВО\n ' +
                                '«АмГУ», АмГУ л/с 20236Х50560)\n ' +
                                'р/с 03214643000000012300\n ' +
                                'ОТДЕЛЕНИЕ БЛАГОВЕЩЕНСК БАНК РОССИИ// УФК по\n ' +
                                'Амурской области г. Благовещенск,\n ' +
                                'БИК 011012100,\n ' +
                                'Кор. счет 40102810245370000015,\n ' +
                                'Назначение платежа КБК 00000000000000000130\n ' +
                                'ОКТМО: 10701000\n ' +
                                'ОКАТО: 10401000000\n ',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: 'Наниматель\n' +
                                `${full_name}\n` +
                                `\n` +
                                `Данные паспорта\n` +
                                `${identity_card.passport_data.issuing_authority} ${identity_card.passport_data.subdivision_code} ${identity_card.passport_data.issue_date}\n` +
                                `Адрес регистрации: ${registration_address}\n` +
                                `Серия и номер: ${identity_card.passport_data.series} ${identity_card.passport_data.number}\n` +
                                `\n` +
                                `ИНН: ${identity_card.inn}\n` +
                                `СНИЛС: ${identity_card.snils}\n`,
                            style: 'column'
                        },
                    ],
                    margin: [0, 10, 0, 0]
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: '_____________________В.В.Ерёмина',
                            alignment: 'left',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: '____________________________________',
                            alignment: 'right',
                            style: 'column'
                        },
                    ],
                },
                //////////////////////////////Прилодение №2//////////////////////////////////////////////////
                {
                    columns: [
                        {
                            width: '50%',
                            text: '',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: 'Приложение № 2\n' +
                                'к договору № ___ от __.__.______ года\n' +
                                'найма жилого помещения в студенческом общежитии',
                            alignment: 'left',
                            style: 'column'
                        },
                    ],
                    pageBreak: 'before',
                },
                {
                    text: 'ДОПОЛНИТЕЛЬНОЕ СОГЛАШЕНИЕ\n' +
                        'ОБ ИСПОЛЬЗОВАНИИ ЛИЧНЫХ ЭЛЕКТРОПРИБОРОВ',
                    style: 'header',
                    margin: [0, 10, 0, 0]
                },
                {
                    text: 'к договору № ___ от __.__.______ года найма жилого помещения в студенческом общежитии',
                    style: 'normal',
                    alignment: 'center',
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: 'г. Благовещенск',
                            style: 'column',
                            alignment: 'left'
                        },
                        {
                            width: '50%',
                            text: `«___» _____________ ${this.currentYearDate()} год`,
                            alignment: 'right',
                            style: 'column'
                        },
                    ],
                    leadingIndent: 18,
                    margin: [0, 20, 0, 5]
                },
                {
                    text: 'Федеральное государственное бюджетное общеобразовательное учреждение высшего образования «Амурский ' +
                        'государственный университет», именуемое в дальнейшем «Наймодатель» в лице проректора по молодёжной ' +
                        'политике Ерёминой Виктории Владимировны, действующей на основании приказа от 05.09.2022 года № 294-ОД, с ' +
                        'одной стороны, и\n',
                    style: 'normal',
                },
                {
                    text:
                        [
                            'и гражданин(ка)',
                            {text: `   ${full_name} ${this.calcSpace(full_name)}`, style: 'base_text', decoration: 'underline'},
                            ',\n',
                            'именуемый(ая) в дальнейшем «Наниматель», с ' +
                            'другой стороны, вместе именуемые «Стороны», подписали настоящее дополнительное соглашение к договору № __ ' +
                            'от __.__.______ года найма жилого помещения в студенческом общежитии (далее – Договор) о нижеследующем:',
                        ],
                    style: 'normal',
                },
                {
                    text: '1. За пользование личными энергоемкими электроприборами Наниматель дополнительно оплачивает:',
                    style: 'normal',
                    margin: [0, 10, 0, 5]
                },
                {
                    style: 'tableBase',
                    table: {
                        widths: ['50%', '25%', '25%'],
                        headerRows: 3,
                        body: this.tableBodyDevise(electronic_devices)
                    },
                    margin: [0, 0, 0, 10]
                },
                {
                    text: '2. Наниматель вносит плату по настоящему Дополнительному соглашению в порядке, предусмотренном ' +
                        'пунктом 2.3., 2.4. и 2.6. Договора № ___ от __.__.______ года найма жилого помещения в студенческом общежитии.',
                    style: 'normal'
                },
                {
                    text: '3. Настоящее дополнительное соглашение составлено в двух экземплярах, обладающих равной юридической ' +
                        'силой, по одному для каждой из сторон.',
                    style: 'normal'
                },
                {
                    text: '4. Настоящее соглашение является неотъемлемой частью Договора № ___ от __.__.______ года найма жилого ' +
                    'помещения в студенческом общежитии.',
                    style: 'normal'
                },
                {
                    text: '5. Все положения Договора № ___ от __.__.______ года найма жилого помещения в студенческом общежитии, ' +
                        'не затронутые настоящим дополнительным соглашением, сохраняют свою силу.',
                    style: 'normal'
                },
                {
                    text: '6. Настоящее соглашение вступает в силу в момент его подписания и действует на период действия Договора ' +
                        '№ ___ от __.__.______ года найма жилого помещения в студенческом общежитии.',
                    style: 'normal',
                    margin: [0, 0, 0, 10]
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: 'Наймодатель\n' +
                                'ФГБОУ ВО «Амурский государственный университет»\n' +
                                '675027 Россия, г. Благовещенск, Игнатьевское шоссе, 21\n' +
                                'ИНН 2801027174 КПП 280101001',

                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: 'Наниматель\n' +
                                `${full_name}\n` +
                                `\n` +
                                `Данные паспорта\n` +
                                `${identity_card.passport_data.issuing_authority} ${identity_card.passport_data.subdivision_code} ${identity_card.passport_data.issue_date}\n` +
                                `Адрес регистрации: ${registration_address}\n` +
                                `Серия и номер: ${identity_card.passport_data.series} ${identity_card.passport_data.number}\n` +
                                `\n` +
                                `ИНН: ${identity_card.inn}\n` +
                                `СНИЛС: ${identity_card.snils}`,
                            style: 'column'
                        },
                    ],
                    margin: [0, 0, 0, 10]
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: '_____________________В.В.Ерёмина',
                            alignment: 'left',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: '____________________________________',
                            alignment: 'right',
                            style: 'column'
                        },
                    ],
                },
                ///////////////////////////Приложение №3////////////////////////////////////////////
                {
                    columns: [
                        {
                            width: '50%',
                            text: '',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: 'Приложение №3 к договору\n' +
                                'найма жилого помещения в\n' +
                                'общежитии\n' +
                                `от___.___.${this.currentYearDate()}г.№_____`,
                            alignment: 'right',
                            style: 'column'
                        },
                    ],
                    pageBreak: 'before',
                },
                {
                    text: 'ДОПОЛНИТЕЛЬНОЕ СОГЛАШЕНИЕ №_____',
                    style: 'header',
                    margin: [0, 10, 0, 0]
                },
                {
                    text: 'к договору найма жилого помещения в общежитии о переселении \n' +
                        'от «____» ______ 20 ___',
                    style: 'normal',
                    alignment: 'center',
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: 'г. Благовещенск',
                            style: 'column',
                            alignment: 'left'
                        },
                        {
                            width: '50%',
                            text: `«___» _____________ ${this.currentYearDate()} год`,
                            alignment: 'right',
                            style: 'column'
                        },
                    ],
                    leadingIndent: 18,
                    margin: [0, 10, 0, 20]
                },
                {
                    text: [
                        'Федеральное государственное бюджетное общеобразовательное учреждение высшего образования «Амурский ' +
                        'государственный университет», именуемое по договору «Наймодатель» в лице проректора по молодёжной политике Ерёминой ' +
                        'Виктории Владимировны, действующей на основании приказа от 05.09.2022 года № 294-ОД, с одной стороны,\n',
                        'и гражданин(ка)',
                        {text: `   ${full_name} ${this.calcSpace(full_name)}`, style: 'base_text', decoration: 'underline'}, `, паспорт ` +
                        `серии ${identity_card.passport_data.series} № ${identity_card.passport_data.number} выдан ${identity_card.passport_data.issuing_authority}, именуемый(ая) ` +
                        'по договору «Наниматель», на основании приказа АмГУ от ____________ № ________, заключили настоящий Договор о нижеследующем.',
                    ],
                    style: 'normal'
                },
                {
                    text: 'Стороны пришли к соглашению о внесении в договор найма жилого помещения в ' +
                        'общежитии от «___» _______ 20___г. (далее - договор) изменения, изложив пункт 1.1 в следующей ' +
                        'редакции:',
                    style: 'normal'
                },
                {
                    text: '1. Наймодатель предоставляет Нанимателю для временного проживания место в комнате № ' +
                        '___ секции № ___, расположенного по адресу: г. Благовещенск, ул.________________, дом № _____',
                    style: 'normal'
                },
                {
                    text: '2. Настоящее дополнительное соглашение вступает в силу с момента его подписания и ' +
                        'становится обязательным для сторон, заключивших его.',
                    style: 'normal'
                },
                {
                    text: '3. Настоящее дополнительное соглашение является неотъемлемой частью основного договора ' +
                        'о найме жилого помещения общежития от «__»__________ 20___г. и все вопросы, связанные с ним, ',
                    style: 'normal'
                },
                {
                    text: '4. По всем вопросам, не нашедшим своего решения в условиях настоящего дополнительного ' +
                        'соглашения, но прямо или косвенно вытекающим из отношений сторон по нему, стороны будут ' +
                        'руководствоваться нормами и положениями действующего законодательства РФ.',
                    style: 'normal'
                },
                {
                    text: '5. Настоящее дополнительное соглашение составлено в двух экземплярах: по одному для ' +
                        'каждой стороны договора, причем все экземпляры имеют равную юридическую силу.',
                    style: 'normal'
                },
                { text: 'Подписи сторон:', style: 'normal', alignment: 'center', margin: [0, 30, 0, 10]},
                {
                    columns: [
                        {
                            width: '50%',
                            text: 'Наниматель:\n' +
                                `${full_name}\n` +
                                `\n` +
                                `Данные паспорта\n` +
                                `${identity_card.passport_data.issuing_authority} ${identity_card.passport_data.subdivision_code} ${identity_card.passport_data.issue_date}\n` +
                                `Адрес регистрации: ${registration_address}\n` +
                                `Серия и номер: ${identity_card.passport_data.series} ${identity_card.passport_data.number}\n` +
                                `\n` +
                                `ИНН: ${identity_card.inn}\n` +
                                `СНИЛС: ${identity_card.snils}\n`,
                            style: 'column',
                            alignment: 'center'
                        },
                        {
                            width: '50%',
                            text: 'Наймодатель\n' +
                                'Федеральное государственное бюджетное\n' +
                                'образовательное учреждение высшего\n' +
                                'образования «Амурский государственный\n' +
                                'университет»\n' +
                                'Игнатьевское шоссе, 21, г. Благовещенск\n' +
                                'Россия, 675027\n' +
                                'тел.: (4162) 23-45-01; факс: (4162) 23-45-25\n' +
                                'E-mail: master@amursu.ru',
                            style: 'column',
                            alignment: 'center'
                        },
                    ],
                    margin: [0, 0, 0, 30]
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: '__________________\n' +
                                '(подпись)',
                            alignment: 'center',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: '_________________/Ерёмина В.В.\n' +
                                '(подпись)   м.п.    ФИО',
                            alignment: 'center',
                            style: 'column'
                        },
                    ],
                },
                //////////////////////////////Приложение №4////////////////////////////////////////////
                {
                    columns: [
                        {
                            width: '50%',
                            text: '',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: 'Приложение № 4\n' +
                                'к договору № ___ от __.__.______ года\n' +
                                'найма жилого помещения в студенческом общежитии',
                            alignment: 'left',
                            style: 'column'
                        },
                    ],
                    pageBreak: 'before',
                },
                {
                    text: 'АКТ ВОЗВРАТА ЖИЛОГО ПОМЕЩЕНИЯ',
                    style: 'header',
                    margin: [0, 20, 0, 10]
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: 'Город Благовещенск Амурской области',
                            style: 'column',
                            alignment: 'left'
                        },
                        {
                            width: '50%',
                            text: `«___» _________________ ${this.currentYearDate()} г.`,
                            alignment: 'right',
                            style: 'column'
                        },
                    ],
                    leadingIndent: 18,
                    margin: [0, 0, 0, 10]
                },
                {
                    text: 'Федеральное государственное бюджетное общеобразовательное учреждение высшего образования «Амурский ' +
                        'государственный университет», именуемое по договору «Наймодатель» в лице проректора по молодёжной политике ' +
                        'Ерёминой Виктории Владимировны, действующей на основании приказа от 05.09.2022 года № 294-ОД, с одной ' +
                        'стороны,',
                    style: 'normal'
                },
                {   text: [
                        'и гражданин(ка)',
                        {text: `   ${full_name} ${this.calcSpace(full_name)}`, style: 'base_text', decoration: 'underline'},
                        'именуемый(ая) по договору «Наниматель», с другой стороны, вместе именуемые в дальнейшем "Стороны", составили ' +
                        'настоящий Акт о нижеследующем:',
                    ],
                    style: 'normal'
                },
                {
                    text: '1. Во исполнение условий Договора № ___ от __.__.______ года найма жилого помещения в студенческом ' +
                        'общежитии Наниматель возвращает, а Наймодатель принимает обратно место в комнате № ____, секции № _____, ' +
                        'общежития № ______, расположенного по адресу ___________________________________, общей площадью _____ кв.м. (жилое ' +
                        'помещение), находящегося в государственной собственности, закрепленного за Наймодателем на праве оперативного управления .',
                    style: 'normal',
                    margin: [0, 10, 0, 0]
                },
                {
                    text: '2. Техническое состояние жилого помещения на момент его возврата характеризуется следующим:\n' +
                        '_____________________________________________________________________________________________________________________________' +
                        '_____________________________________________________________________________________________________________________________' +
                        '__________________________________________________________________________________________.',
                    style: 'normal',
                },
                {
                    text: '3. Наниматель возвращает следующее имущество Наймодателя (оборудование, мебель и инвентарь):',
                    style: 'normal',
                },
                {
                    style: 'tableBase',
                    table: {
                        widths: ['70%', '10%', '20%'],
                        headerRows: 3,
                        heights: 7,
                        body: [
                            [{text: 'Наименование', style: 'tableHeader', alignment: 'left'}, {text: 'Количество', style: 'tableHeader', alignment: 'center'}, {text: 'Инвентарный номер', style: 'tableHeader', alignment: 'center'}],
                            ['', '', ''],
                            ['', '', ''],
                            ['', '', ''],
                            ['', '', ''],
                            ['', '', ''],
                            ['', '', ''],
                            ['', '', ''],
                            ['', '', ''],
                            ['', '', ''],
                            ['', '', ''],
                        ]
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            return 0.4;
                        },
                        vLineWidth: function (i, node) {
                            return 0.4;
                        },
                        hLineColor: function (i, node) {
                            return 'black'
                        },
                        vLineColor: function (i, node) {
                            return 'black'
                        },
                    }
                },
                {
                    text: 'Состояние возвращенного имущества: ___________________________________________________________________________\n' +
                        '_________________________________________________________________________________________' +
                        '________________________________________________________________________________________________________________' +
                        '__________________________.',
                        style: 'normal'
                },
                {
                    text: '4. Выявленные недостатки возвращаемого жилого помещения: _____________________________________________________\n' +
                        '___________________________________________________________________________________________________________' +
                        '________________________________________________________________________________________________________________________.',
                    style: 'normal'
                },
                {
                    text: 'Стороны договорились о следующих сроках устранения выявленных недостатков: ___________________________________\n' +
                        '___________________________________________________________________________________________________' +
                        '________________________________________________________________________________________________________.',
                    style: 'normal'
                },
                {
                    text: '5. Наймодатель ключи от жилого помещения получил.',
                    style: 'normal'
                },
                {
                    text: '6. Задолженность по оплате проживания в студенческом общежитии у Нанимателя _______________________________ .',
                    style: 'normal'
                },
                {
                    text: 'Бухгалтер ________/_____________/__.__.202_г.',
                    style: 'normal',
                    alignment: 'right'
                },
                {
                    text: '7. Стороны взаимных претензий друг к другу не имеют, кроме прямо оговоренных в настоящем Акте.',
                    style: 'normal',
                },
                {
                    text: '8. Настоящий Акт является неотъемлемой частью Договора № ___ от __.__.______ года найма жилого ' +
                        'помещения в студенческом общежитии.',
                    style: 'normal',
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: 'Наймодатель\n' +
                                'Федеральное государственное бюджетное образовательное ' +
                                'учреждение высшего образования\n ' +
                                '«Амурский государственный университет»\n ' +
                                '675027 Россия, г. Благовещенск, Игнатьевское шоссе, 21\n ' +
                                'ИНН 2801027174 КПП 280101001',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: 'Наниматель\n' +
                                `${full_name}\n` +
                                `\n` +
                                `Данные паспорта\n` +
                                `${identity_card.passport_data.issuing_authority} ${identity_card.passport_data.subdivision_code} ${identity_card.passport_data.issue_date}\n` +
                                `Адрес регистрации: ${registration_address}\n` +
                                `Серия и номер: ${identity_card.passport_data.series} ${identity_card.passport_data.number}\n` +
                                `\n` +
                                `ИНН: ${identity_card.inn}\n` +
                                `СНИЛС: ${identity_card.snils}\n`,
                            style: 'column'
                        },
                    ],
                    margin: [0, 10, 0, 0]
                },
                {
                    columns: [
                        {
                            width: '50%',
                            text: '_____________________В.В.Ерёмина',
                            alignment: 'left',
                            style: 'column'
                        },
                        {
                            width: '50%',
                            text: '____________________________________',
                            alignment: 'right',
                            style: 'column'
                        },
                    ],
                    margin: [0, 20, 0, 0]
                },
            ],

            styles : {
                base_text:{
                    fontSize: 9,
                    font: 'Times'
                },
                name_contract: {
                    fontSize: 9,
                    alignment: 'center',
                    bold: true,
                    font: 'Times'
                },
                header:{
                    fontSize: 9,
                    alignment: 'center',
                    font: 'Times'
                },
                normal: {
                    fontSize: 9,
                    alignment: 'justify',
                    font: 'Times',
                    leadingIndent: 18
                },
                column: {
                    fontSize: 9,
                    alignment: 'left',
                    font: 'Times'
                },
                tableBase: {
                    fontSize: 9,
                    font: 'Times'
                },
                tableHeader: {
                    fontSize: 9,
                    font: 'Times'
                },
            }
        }
        pdfMake.createPdf(docInfo).open();
        // pdfMake.createPdf(docInfo).create(`Договор на заселение-${full_name}.pdf`);
    }
}